import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives, withCtx as _withCtx, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "container-fluid" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { name: "form" }
const _hoisted_4 = { class: "contain row" }
const _hoisted_5 = {
  key: 1,
  class: "page-container card col-md-8"
}
const _hoisted_6 = {
  key: 0,
  class: "row"
}
const _hoisted_7 = { class: "col-md-12 p-4" }
const _hoisted_8 = { class: "row mb-3" }
const _hoisted_9 = { class: "col-md-6" }
const _hoisted_10 = { class: "col-md-6" }
const _hoisted_11 = { class: "row mb-3" }
const _hoisted_12 = { class: "col-md-2 d-flex align-items-center" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("span", { class: "p-1" }, null, -1)
const _hoisted_14 = { class: "d-flex col-md-10 justify-content-end" }
const _hoisted_15 = {
  key: 0,
  class: "p-2"
}
const _hoisted_16 = {
  key: 1,
  class: "p-2"
}
const _hoisted_17 = {
  key: 0,
  class: "d-flex justify-content-center"
}
const _hoisted_18 = ["id", "onChange"]
const _hoisted_19 = /*#__PURE__*/_createElementVNode("span", null, "Status", -1)
const _hoisted_20 = { class: "d-flex justify-content-center" }
const _hoisted_21 = { key: 0 }
const _hoisted_22 = {
  key: 1,
  class: "error-no-record mt-3"
}
const _hoisted_23 = /*#__PURE__*/_createElementVNode("h6", null, [
  /*#__PURE__*/_createElementVNode("span", null, "No Record Found")
], -1)
const _hoisted_24 = { class: "row p-3" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-3" }, null, -1)
const _hoisted_26 = /*#__PURE__*/_createElementVNode("div", { class: "d-flex col-md-4" }, null, -1)
const _hoisted_27 = { class: "d-flex col-md-5 justify-content-end" }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("span", { class: "p-1" }, null, -1)
const _hoisted_29 = /*#__PURE__*/_createElementVNode("span", { class: "p-1" }, null, -1)
const _hoisted_30 = { key: 0 }
const _hoisted_31 = { key: 1 }
const _hoisted_32 = /*#__PURE__*/_createElementVNode("p", null, " The system is calculating, please do not refresh the page or close the window while calculating. ", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TheHeader = _resolveComponent("TheHeader")!
  const _component_TheSidebar = _resolveComponent("TheSidebar")!
  const _component_ThePageLoading = _resolveComponent("ThePageLoading")!
  const _component_ThePageHeader = _resolveComponent("ThePageHeader")!
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_MultiSelect = _resolveComponent("MultiSelect")!
  const _component_Button = _resolveComponent("Button")!
  const _component_TheLoading = _resolveComponent("TheLoading")!
  const _component_Checkbox = _resolveComponent("Checkbox")!
  const _component_Column = _resolveComponent("Column")!
  const _component_ProgressSpinner = _resolveComponent("ProgressSpinner")!
  const _component_FontAwesomeIcon = _resolveComponent("FontAwesomeIcon")!
  const _component_DataTable = _resolveComponent("DataTable")!
  const _component_SplitButton = _resolveComponent("SplitButton")!
  const _component_TheSheetsDialog = _resolveComponent("TheSheetsDialog")!
  const _component_ThePageError = _resolveComponent("ThePageError")!
  const _component_TheFooter = _resolveComponent("TheFooter")!
  const _component_Dialog = _resolveComponent("Dialog")!
  const _component_TheSheetsCommentsDialog = _resolveComponent("TheSheetsCommentsDialog")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_TheHeader),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("form", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_TheSidebar),
            (_ctx.isPageLoading)
              ? (_openBlock(), _createBlock(_component_ThePageLoading, { key: 0 }))
              : _createCommentVNode("", true),
            (!_ctx.isPageLoading)
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                  _createVNode(_component_ThePageHeader),
                  (_ctx.pageError == '')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                        _createElementVNode("div", _hoisted_7, [
                          _createElementVNode("div", _hoisted_8, [
                            _createElementVNode("div", _hoisted_9, [
                              _createVNode(_component_Dropdown, {
                                options: _ctx.companyReportTypes,
                                optionLabel: "name",
                                optionValue: "value",
                                filter: "",
                                showClear: "",
                                placeholder: "Type",
                                modelValue: _ctx.companyReportDetailsFilter.typeFilter,
                                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.companyReportDetailsFilter.typeFilter) = $event)),
                                onChange: _ctx.filterCompanyReportDetail
                              }, null, 8, ["options", "modelValue", "onChange"])
                            ]),
                            _createElementVNode("div", _hoisted_10, [
                              _createVNode(_component_MultiSelect, {
                                options: _ctx.companyReportLoadStatuses,
                                optionLabel: "name",
                                optionValue: "value",
                                filter: "",
                                placeholder: "Status",
                                modelValue: _ctx.companyReportDetailsFilter.statusFilter,
                                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.companyReportDetailsFilter.statusFilter) = $event)),
                                display: "chip",
                                onChange: _ctx.filterCompanyReportDetail
                              }, null, 8, ["options", "modelValue", "onChange"])
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_11, [
                            _createElementVNode("div", _hoisted_12, [
                              _createVNode(_component_Button, {
                                class: "p-button-sm p-button-warning",
                                onClick: _ctx.clear,
                                label: "Clear"
                              }, null, 8, ["onClick"]),
                              _hoisted_13,
                              _createVNode(_component_Button, {
                                class: "p-button-sm p-button-secondary",
                                onClick: _ctx.back,
                                label: "Back"
                              }, null, 8, ["onClick"])
                            ]),
                            _createElementVNode("div", _hoisted_14, [
                              ((_ctx.isCompanyDetailProcessing || _ctx.isCompanyReportLoading) && _ctx.remainingLoadCount > 0)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_15, _toDisplayString("Remaining file(s): " + _ctx.remainingLoadCount), 1))
                                : _createCommentVNode("", true),
                              ((_ctx.isCompanyDetailProcessing || _ctx.isCompanyReportLoading) && _ctx.remainingLoadCount == 0 || _ctx.isImporting || _ctx.isExporting)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_16, _toDisplayString("Processing")))
                                : _createCommentVNode("", true),
                              (_ctx.isCompanyDetailProcessing || _ctx.isCompanyReportLoading || _ctx.isImporting || _ctx.isExporting)
                                ? (_openBlock(), _createBlock(_component_TheLoading, { key: 2 }))
                                : _createCommentVNode("", true),
                              (_ctx.isAdmin || _ctx.isHQStaff)
                                ? _withDirectives((_openBlock(), _createBlock(_component_Button, {
                                    key: 3,
                                    class: "p-button-sm p-button-danger me-2",
                                    disabled: _ctx.isCompanyDetailProcessing || _ctx.isCompanyReportLoading || _ctx.companyReport.status == 'Finalised',
                                    onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.resetAllCompanyReports())),
                                    label: "Restructure",
                                    hidden: _ctx.isViewer
                                  }, null, 8, ["disabled", "hidden"])), [
                                    [
                                      _directive_tooltip,
                                      'Reset the CWK to apply new Conso Group changes and unlink its data so it can be deleted.',
                                      void 0,
                                      { top: true }
                                    ]
                                  ])
                                : _createCommentVNode("", true),
                              _withDirectives(_createVNode(_component_Button, {
                                class: "p-button-sm p-button-danger me-2",
                                disabled: _ctx.isCompanyDetailProcessing || _ctx.isCompanyReportLoading || _ctx.selectedDetails.length == 0,
                                onClick: _ctx.resetCompanyReports,
                                label: "Unload",
                                hidden: _ctx.isViewer
                              }, null, 8, ["disabled", "onClick", "hidden"]), [
                                [
                                  _directive_tooltip,
                                  'Remove the loaded data and unlink it so it can be deleted.',
                                  void 0,
                                  { top: true }
                                ]
                              ]),
                              _withDirectives(_createVNode(_component_Button, {
                                class: "p-button-sm p-button-warning me-2",
                                disabled: _ctx.isCompanyDetailProcessing || _ctx.isCompanyReportLoading || _ctx.selectedDetails.length == 0,
                                onClick: _ctx.retranslate,
                                label: "Re-translate",
                                hidden: _ctx.isViewer
                              }, null, 8, ["disabled", "onClick", "hidden"]), [
                                [
                                  _directive_tooltip,
                                  'For different-currency items only: reset and reload the data using the latest exchange rate.',
                                  void 0,
                                  { top: true }
                                ]
                              ]),
                              _withDirectives(_createVNode(_component_Button, {
                                class: "p-button-sm p-button-warning me-2",
                                disabled: _ctx.isCompanyDetailProcessing || _ctx.isCompanyReportLoading || _ctx.selectedDetails.length == 0,
                                onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.loadCompanyReports(true))),
                                label: "Update Local Sheet",
                                hidden: _ctx.isViewer
                              }, null, 8, ["disabled", "hidden"]), [
                                [
                                  _directive_tooltip,
                                  'For different-currency items only: finalise the exchange-rate data in the foreign sheet and carry it forward to the local sheet.',
                                  void 0,
                                  { top: true }
                                ]
                              ]),
                              _withDirectives(_createVNode(_component_Button, {
                                class: "p-button-sm p-button-success me",
                                disabled: _ctx.isCompanyDetailProcessing || _ctx.isCompanyReportLoading || _ctx.selectedDetails.length == 0,
                                onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.loadCompanyReports(false))),
                                label: "Load",
                                hidden: _ctx.isViewer
                              }, null, 8, ["disabled", "hidden"]), [
                                [
                                  _directive_tooltip,
                                  'Load data from RPK, CWK (child/subsidiary) and Journal for consolidation.',
                                  void 0,
                                  { top: true }
                                ]
                              ])
                            ])
                          ]),
                          _createVNode(_component_DataTable, {
                            value: _ctx.filteredCompanyReportDetails,
                            paginator: "",
                            rows: 10,
                            paginatorPosition: "top"
                          }, {
                            empty: _withCtx(() => [
                              (_ctx.isLoading)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                                    (_ctx.isLoading)
                                      ? (_openBlock(), _createBlock(_component_TheLoading, { key: 0 }))
                                      : _createCommentVNode("", true)
                                  ]))
                                : (_openBlock(), _createElementBlock("div", _hoisted_22, [
                                    _createVNode(_component_FontAwesomeIcon, {
                                      icon: ['fas', 'image'],
                                      size: "2x"
                                    }),
                                    _hoisted_23
                                  ]))
                            ]),
                            default: _withCtx(() => [
                              _createVNode(_component_Column, { style: {"width":"3%"} }, {
                                header: _withCtx(() => [
                                  _createVNode(_component_Checkbox, {
                                    modelValue: _ctx.isAllDetailsSelected,
                                    binary: true,
                                    disabled: _ctx.isCompanyDetailProcessing || _ctx.isCompanyReportLoading || _ctx.companyReport.status == 'Finalised',
                                    onChange: _ctx.selectAllDetails
                                  }, null, 8, ["modelValue", "disabled", "onChange"])
                                ]),
                                body: _withCtx((slotProps) => [
                                  _createVNode(_component_Checkbox, {
                                    modelValue: slotProps.data.isSelected,
                                    "onUpdate:modelValue": ($event: any) => ((slotProps.data.isSelected) = $event),
                                    binary: true,
                                    disabled: slotProps.data.referenceFileId == '' || slotProps.data.referenceFileId == null || _ctx.isCompanyDetailProcessing || _ctx.isCompanyReportLoading || _ctx.companyReport.status == 'Finalised',
                                    onChange: ($event: any) => (_ctx.selectDetail(slotProps.data))
                                  }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled", "onChange"])
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_Column, {
                                style: {"width":"3%"},
                                header: "#"
                              }, {
                                body: _withCtx((slotProps) => [
                                  _createTextVNode(_toDisplayString(slotProps.index + 1), 1)
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_Column, {
                                style: {"width":"6%"},
                                field: "referenceType",
                                header: "Type"
                              }),
                              _createVNode(_component_Column, {
                                style: {"width":"35%"},
                                field: "referenceName",
                                header: "Name"
                              }),
                              _createVNode(_component_Column, {
                                style: {"width":"20%"},
                                field: "referenceFileId",
                                header: "File ID"
                              }),
                              _createVNode(_component_Column, { style: {"width":"10%"} }, {
                                body: _withCtx((slotProps) => [
                                  (!_ctx.isViewer && slotProps.data.currencyId != null && slotProps.data.currencyId != _ctx.companyReport.currency.identifier)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                                        (slotProps.data.status == 'Pending Translated' || slotProps.data.status == 'Completed')
                                          ? _withDirectives((_openBlock(), _createBlock(_component_Button, {
                                              key: 0,
                                              class: "p-button-sm",
                                              icon: "pi pi-download",
                                              disabled: _ctx.isCompanyDetailProcessing || _ctx.isCompanyReportLoading || _ctx.companyReport.status == 'Finalised',
                                              onClick: ($event: any) => (_ctx.importForeign($event, slotProps.data)),
                                              severity: "secondary",
                                              text: "",
                                              rounded: ""
                                            }, null, 8, ["disabled", "onClick"])), [
                                              [
                                                _directive_tooltip,
                                                'Import FX Rate Amount',
                                                void 0,
                                                { top: true }
                                              ]
                                            ])
                                          : _createCommentVNode("", true),
                                        _createElementVNode("input", {
                                          type: "file",
                                          id: 'custom-file-upload-' + slotProps.data.identifier,
                                          hidden: "",
                                          onChange: ($event: any) => (_ctx.importForeign($event, slotProps.data))
                                        }, null, 40, _hoisted_18),
                                        (slotProps.data.status == 'Pending Translated' || slotProps.data.status == 'Completed')
                                          ? _withDirectives((_openBlock(), _createBlock(_component_Button, {
                                              key: 1,
                                              class: "p-button-sm",
                                              icon: "pi pi-external-link",
                                              disabled: _ctx.isCompanyDetailProcessing || _ctx.isCompanyReportLoading,
                                              onClick: ($event: any) => (_ctx.exportForeign(slotProps.data)),
                                              severity: "secondary",
                                              text: "",
                                              rounded: ""
                                            }, null, 8, ["disabled", "onClick"])), [
                                              [
                                                _directive_tooltip,
                                                'Export FX Rate Amount',
                                                void 0,
                                                { top: true }
                                              ]
                                            ])
                                          : _createCommentVNode("", true)
                                      ]))
                                    : _createCommentVNode("", true)
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_Column, {
                                style: {"width":"5%"},
                                field: "status"
                              }, {
                                header: _withCtx(() => [
                                  _hoisted_19,
                                  (_ctx.isForceResetButtonVisible && _ctx.isAdmin)
                                    ? _withDirectives((_openBlock(), _createBlock(_component_Button, {
                                        key: 0,
                                        class: "p-button-sm p-button-text",
                                        style: {"padding":"0px"},
                                        icon: "pi pi-refresh",
                                        onClick: _ctx.forceResetCompanyReports
                                      }, null, 8, ["onClick"])), [
                                        [
                                          _directive_tooltip,
                                          'Force Reset Processing Reports',
                                          void 0,
                                          { top: true }
                                        ]
                                      ])
                                    : _createCommentVNode("", true)
                                ]),
                                body: _withCtx((slotProps) => [
                                  _createElementVNode("div", _hoisted_20, [
                                    (slotProps.data.status == 'Pending' )
                                      ? _withDirectives((_openBlock(), _createElementBlock("i", {
                                          key: 0,
                                          class: "pi pi-clock",
                                          style: _normalizeStyle({color: 'var(--primary-color)'})
                                        }, null, 4)), [
                                          [
                                            _directive_tooltip,
                                            slotProps.data.status,
                                            void 0,
                                            { top: true }
                                          ]
                                        ])
                                      : _createCommentVNode("", true),
                                    (slotProps.data.status == 'Pending Translated' )
                                      ? _withDirectives((_openBlock(), _createElementBlock("i", {
                                          key: 1,
                                          class: "pi pi-file-import",
                                          style: _normalizeStyle({color: 'var(--primary-color)'})
                                        }, null, 4)), [
                                          [
                                            _directive_tooltip,
                                            slotProps.data.status,
                                            void 0,
                                            { top: true }
                                          ]
                                        ])
                                      : (slotProps.data.status == 'Processing')
                                        ? _withDirectives((_openBlock(), _createBlock(_component_ProgressSpinner, {
                                            key: 2,
                                            style: {"width":"1.5rem","height":"1.5rem"},
                                            strokeWidth: "5"
                                          }, null, 512)), [
                                            [
                                              _directive_tooltip,
                                              slotProps.data.status,
                                              void 0,
                                              { top: true }
                                            ]
                                          ])
                                        : (slotProps.data.status == 'Completed')
                                          ? _withDirectives((_openBlock(), _createElementBlock("i", {
                                              key: 3,
                                              class: "pi pi-check",
                                              style: _normalizeStyle({color: 'var(--primary-color)'})
                                            }, null, 4)), [
                                              [
                                                _directive_tooltip,
                                                slotProps.data.status,
                                                void 0,
                                                { top: true }
                                              ]
                                            ])
                                          : (slotProps.data.status == 'Error')
                                            ? _withDirectives((_openBlock(), _createElementBlock("i", {
                                                key: 4,
                                                class: "pi pi-exclamation-circle",
                                                style: _normalizeStyle({color: 'var(--bs-danger)'})
                                              }, null, 4)), [
                                                [
                                                  _directive_tooltip,
                                                  slotProps.data.status,
                                                  void 0,
                                                  { top: true }
                                                ]
                                              ])
                                            : _createCommentVNode("", true)
                                  ])
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_Column, {
                                style: {"width":"18%"},
                                field: "statusDate",
                                header: "Status Date"
                              })
                            ]),
                            _: 1
                          }, 8, ["value"]),
                          _createElementVNode("div", _hoisted_24, [
                            _hoisted_25,
                            _hoisted_26,
                            _createElementVNode("div", _hoisted_27, [
                              (_ctx.identifier != null)
                                ? (_openBlock(), _createBlock(_component_SplitButton, {
                                    key: 0,
                                    class: "p-button-sm p-button-warning",
                                    disabled: _ctx.isLoading || _ctx.isCompanyDetailProcessing || _ctx.isCompanyReportLoading || _ctx.isCalculating || !_ctx.hasCompanyDetailCompleted || _ctx.companyReport.status == 'Finalised',
                                    hidden: _ctx.isViewer,
                                    onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.calculate(1, false))),
                                    label: "Calculate",
                                    model: _ctx.calculateSplitButtonItems
                                  }, null, 8, ["disabled", "hidden", "model"]))
                                : _createCommentVNode("", true),
                              _hoisted_28,
                              (_ctx.identifier != null)
                                ? (_openBlock(), _createBlock(_component_SplitButton, {
                                    key: 1,
                                    class: "p-button-sm p-button-warning",
                                    disabled: _ctx.isLoading || _ctx.isCompanyDetailProcessing || _ctx.isCompanyReportLoading || _ctx.isCalculating,
                                    onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.checkUnsaved(1))),
                                    label: "Local",
                                    model: _ctx.localSplitButtonItems
                                  }, null, 8, ["disabled", "model"]))
                                : _createCommentVNode("", true),
                              _hoisted_29,
                              (_ctx.identifier != null)
                                ? (_openBlock(), _createBlock(_component_SplitButton, {
                                    key: 2,
                                    class: "p-button-sm p-button-warning",
                                    disabled: _ctx.isLoading || _ctx.isCompanyDetailProcessing || _ctx.isCompanyReportLoading || _ctx.isCalculating,
                                    onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.checkUnsaved(2))),
                                    label: "Foreign",
                                    model: _ctx.foreignSplitButtonItems
                                  }, null, 8, ["disabled", "model"]))
                                : _createCommentVNode("", true)
                            ])
                          ])
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  _createVNode(_component_TheSheetsDialog, {
                    identifier: _ctx.dialog.identifier,
                    name: _ctx.dialog.fileId,
                    type: 'cwk',
                    balanceSheetDate: _ctx.dialog.balanceSheetDate == null ? null : _ctx.formatToDate(_ctx.dialog.balanceSheetDate),
                    currencyCode: _ctx.dialog.currencyCode,
                    purpose: _ctx.dialog.purpose,
                    id: _ctx.dialog.id,
                    templateIndex: _ctx.dialog.templateIndex,
                    status: _ctx.dialog.status,
                    autoSaveFailed: _ctx.dialog.autoSaveFailed,
                    visible: _ctx.dialog.visible,
                    loading: _ctx.dialog.loading,
                    isUnsaved: _ctx.dialog.isUnsaved,
                    reportSheets: _ctx.dialog.companyReportSheets,
                    onSave: _ctx.updateSheets,
                    onAutoSave: _ctx.updateSheetCached,
                    onDeleteCached: _ctx.deleteSheetCached,
                    onCancel: _ctx.closeDialog
                  }, null, 8, ["identifier", "name", "balanceSheetDate", "currencyCode", "purpose", "id", "templateIndex", "status", "autoSaveFailed", "visible", "loading", "isUnsaved", "reportSheets", "onSave", "onAutoSave", "onDeleteCached", "onCancel"]),
                  (_ctx.pageError != '')
                    ? (_openBlock(), _createBlock(_component_ThePageError, {
                        key: 1,
                        onBackEvent: _ctx.cancel,
                        pageError: _ctx.pageError
                      }, null, 8, ["onBackEvent", "pageError"]))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true),
            _createVNode(_component_TheFooter)
          ])
        ])
      ])
    ]),
    _createVNode(_component_Dialog, {
      visible: _ctx.isShowUnsavedConfirmation,
      "onUpdate:visible": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.isShowUnsavedConfirmation) = $event)),
      header: "Recover Unsaved Changes",
      modal: "",
      style: { width: '40vw' }
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_Button, {
          label: "No",
          icon: "pi pi-times",
          onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.sheets(_ctx.dialog.templateIndex, false, null))),
          text: ""
        }),
        _createVNode(_component_Button, {
          label: "Yes",
          icon: "pi pi-check",
          onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.sheets(_ctx.dialog.templateIndex, true, null))),
          hidden: _ctx.isViewer
        }, null, 8, ["hidden"])
      ]),
      default: _withCtx(() => [
        (_ctx.isViewer)
          ? (_openBlock(), _createElementBlock("p", _hoisted_30, " Any data entered by you (as a viewer) will not be saved or processed "))
          : (_openBlock(), _createElementBlock("p", _hoisted_31, " Unsaved changes detected and available to recovery. Would you like to recover these changes now? "))
      ]),
      _: 1
    }, 8, ["visible"]),
    _createVNode(_component_Dialog, {
      visible: _ctx.isCalculating,
      "onUpdate:visible": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.isCalculating) = $event)),
      header: "Calculating",
      modal: "",
      style: { width: '40vw' },
      closable: false
    }, {
      footer: _withCtx(() => [
        (_ctx.isCalculating)
          ? (_openBlock(), _createBlock(_component_TheLoading, { key: 0 }))
          : _createCommentVNode("", true)
      ]),
      default: _withCtx(() => [
        _hoisted_32
      ]),
      _: 1
    }, 8, ["visible"]),
    _createVNode(_component_TheSheetsCommentsDialog, { ref: "sheetsCommentsDialog" }, null, 512)
  ], 64))
}